import { DangerAlert, SuccessAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import RoleName from "enums/RoleName";
import Log from "interfaces/Log";
import * as moment from "moment";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import isInRole from "utils/isInRole";
import getJwtToken from "../../utils/getJwtToken";
import { MsalContext } from "../common/msal";
import ContentLoading from "components/common/ContentLoading";

interface State {
    isLoading: boolean;
    isAdmin: boolean;
    data: {
        customerSyncLogs: Log[];
        productSyncLogs: Log[];
        vendorSyncLogs: Log[];
        jobSyncLogs: Log[];
    };
    isSyncingProducts: boolean;
    isSyncingCustomers: boolean;
    isSyncingVendors: boolean;
    isSyncingJobs: boolean;
    isImportingTaxRates: boolean;
    isImportingData: boolean;
    spinner: boolean;
    statusMessage?: {
        type: "success" | "error";
        message: string;
    };
}

export default class Index extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    static contextType = MsalContext;
    context!: React.ContextType<typeof MsalContext>;
    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            isLoading: true,
            isAdmin: false,
            data: {} as any,
            isSyncingProducts: false,
            isSyncingCustomers: false,
            isSyncingVendors: false,
            isSyncingJobs: false,
            isImportingTaxRates: false,
            isImportingData: false,
            spinner: true,
            statusMessage: undefined,
        };

        this.syncProducts = this.syncProducts.bind(this);
        this.syncCustomers = this.syncCustomers.bind(this);
        this.syncVendorsAndSalesPeople = this.syncVendorsAndSalesPeople.bind(this);
        this.syncJobs = this.syncJobs.bind(this);
        this.importTaxRates = this.importTaxRates.bind(this);
        this.importData = this.importData.bind(this);
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading topOffset={350} />
                </div>
            );
        }

        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Settings</BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.statusMessage &&
                        (this.state.statusMessage.type === "success" ? (
                            <SuccessAlert name="statusAlert">
                                {this.state.statusMessage.message}
                            </SuccessAlert>
                        ) : (
                            <DangerAlert name="statusAlert">
                                {this.state.statusMessage.message}
                            </DangerAlert>
                        ))}
                    {this.state.isAdmin && (
                        <div className="button-group d-flex justify-content-between">
                            <div>
                                <Link to="/settings/tax" className="button__item me-2">
                                    <i className="icon-tax"></i> Tax
                                </Link>
                                <Link to="/settings/logs" className="button__item">
                                    <i className="icon-folder"></i> View Logs
                                </Link>
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="card__title">Recent Process Logs</h2>
                        </div>
                        <div className="col-md-6">
                            <div className="card card--datatables">
                                <div className="card-block">
                                    <div className="row">
                                        <div className="col-6">
                                            <h5>Items</h5>
                                        </div>
                                    </div>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Date & Time</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data.productSyncLogs.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{moment(item.date).format("l, LT")}</td>
                                                    <td>{item.message}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div style={{ marginTop: "10px" }}>
                                        {this.state.isSyncingProducts ? (
                                            <button className="btn btn-primary">
                                                <span className="btn__animated-icon">
                                                    <i className="icon-process"></i>
                                                </span>{" "}
                                                Syncing
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-primary"
                                                onClick={this.syncProducts}
                                            >
                                                <i className="icon-products-black"></i>Sync Items Manually
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card card--datatables">
                                <div className="card-block">
                                    <div className="row">
                                        <div className="col-6">
                                            <h5>Customers</h5>
                                        </div>
                                    </div>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Date & Time</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data.customerSyncLogs.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{moment(item.date).format("l, LT")}</td>
                                                    <td>{item.message}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div style={{ marginTop: "10px" }}>
                                        {this.state.isSyncingCustomers ? (
                                            <button className="btn btn-primary">
                                                <span className="btn__animated-icon">
                                                    <i className="icon-process"></i>
                                                </span>{" "}
                                                Syncing
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-primary"
                                                onClick={this.syncCustomers}
                                            >
                                                <i className="icon-customers-black"></i>Sync Customers Manually
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card card--datatables">
                                <div className="card-block">
                                    <div className="row">
                                        <div className="col-6">
                                            <h5>Vendors / SalesPeople</h5>
                                        </div>
                                    </div>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Date & Time</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data.vendorSyncLogs.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{moment(item.date).format("l, LT")}</td>
                                                    <td>{item.message}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div style={{ marginTop: "10px" }}>
                                        {this.state.isSyncingVendors ? (
                                            <button className="btn btn-primary">
                                                <span className="btn__animated-icon">
                                                    <i className="icon-process"></i>
                                                </span>{" "}
                                                Syncing
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-primary"
                                                onClick={this.syncVendorsAndSalesPeople}
                                            >
                                                <i className="icon-vendors-black"></i>Sync Vendors/Sales People Manually
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card card--datatables">
                                <div className="card-block">
                                    <div className="row">
                                        <div className="col-6">
                                            <h5>Projects</h5>
                                        </div>
                                    </div>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Date & Time</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data.jobSyncLogs.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{moment(item.date).format("l, LT")}</td>
                                                    <td>{item.message}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div style={{ marginTop: "10px" }}>
                                        {this.state.isSyncingJobs ? (
                                            <button className="btn btn-primary">
                                                <span className="btn__animated-icon">
                                                    <i className="icon-process"></i>
                                                </span>{" "}
                                                Syncing
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-primary"
                                                onClick={this.syncJobs}
                                            >
                                                <i className="icon-jobs"></i>Sync Projects Manually
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.isAdmin && (
                        <div className="row mb-5">
                            <div className="col-md-6">
                                <div className="card-block">
                                    {this.state.isImportingTaxRates ? (
                                        <button className="btn btn-primary">
                                            <span className="btn__animated-icon">
                                                <i className="icon-process"></i>
                                            </span>{" "}
                                            Importing
                                        </button>
                                    ) : (
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.importTaxRates}
                                        >
                                            <i className="icon-tax"></i>Import Tax Rates
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card-block">
                                    {this.state.isImportingData ? (
                                        <button className="btn btn-primary">
                                            <span className="btn__animated-icon">
                                                <i className="icon-process"></i>
                                            </span>{" "}
                                            Importing
                                        </button>
                                    ) : (
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.importData}
                                        >
                                            <i className="icon-download"></i>Import Data
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        );
    }

    public async componentDidMount() {
        let token = getJwtToken();
        if (token === null || new Date().getTime() >= token.exp * 1000) {
            const accounts = this.context.accounts;
            if (accounts.length > 0) {
                let config = require(`../../config.${HostingEnv}.ts`) as any;
                const scope = BQS
                    ? config.authRequestBQS.scopes[0]
                    : config.authRequestCQS.scopes[0];
                const account = this.context.accounts[0];
                if (account) {
                    const request = {
                        scopes: [scope],
                        account: account,
                        interactionType: 'Silent'
                    };
                    const instance = this.context.instance;
                    await instance
                        .acquireTokenSilent(request)
                        .then((response) => {
                            if (response) {
                                localStorage.setItem("access_token", response.accessToken);
                            }
                        })
                        .catch(async (err) => {
                            //console.log("SI: Silent token acquisition failed, acquiring token interactively...", err);

                            await instance.loginRedirect({
                                scopes: [scope],
                                account: account
                            });
                        });
                }
            }
        }
        if (this.state.isLoading) {
            let response = await apifetch("settings", undefined, true);
            if (response.ok) {
                let data = await response.json();
                this.setState({
                    isLoading: false,
                    data: data,
                    isAdmin: isInRole(RoleName.Admin)
                });

                document.title = "Settings - " + SITE_NAME;
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    statusMessage: { type: "error", message: errorText },
                });
            }
        }
    }

    private async syncProducts() {
        if (window.confirm('Are you sure you want to sync items?')) {
            this.setState({
                isSyncingProducts: true,
                statusMessage: undefined,
            });

            let response = await apifetch(
                "settings/sync/products",
                {
                    method: "POST",
                },
                true
            );

            if (response.ok) {
                let response = await apifetch("settings", undefined, true);
                if (response.ok) {
                    let data = await response.json();
                    this.state.data.productSyncLogs = data.productSyncLogs;
                    this.setState({
                        isSyncingProducts: false,
                        data: this.state.data,
                        statusMessage: { type: "success", message: "Items synced successfully." },
                    });
                } else {
                    const errorText = await extractErrorMessage(response);
                    this.setState({
                        isSyncingProducts: false,
                        statusMessage: { type: "error", message: errorText },
                    });
                }
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isSyncingProducts: false,
                    statusMessage: { type: "error", message: errorText },
                });
            }
        }
    }

    private async syncCustomers() {
        if (window.confirm('Are you sure you want to sync customers?')) {
            this.setState({
                isSyncingCustomers: true,
                statusMessage: undefined,
            });

            let response = await apifetch(
                "settings/sync/customers",
                {
                    method: "POST",
                },
                true
            );

            if (response.ok) {
                let response = await apifetch("settings", undefined, true);
                if (response.ok) {
                    let data = await response.json();
                    this.state.data.customerSyncLogs = data.customerSyncLogs;
                    this.setState({
                        isSyncingCustomers: false,
                        data: this.state.data,
                        statusMessage: { type: "success", message: "Customers synced successfully." },
                    });
                } else {
                    const errorText = await extractErrorMessage(response);
                    this.setState({
                        isSyncingCustomers: false,
                        statusMessage: { type: "error", message: errorText },
                    });
                }
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isSyncingCustomers: false,
                    statusMessage: { type: "error", message: errorText },
                });
            }
        }
    }

    private async syncVendorsAndSalesPeople() {
        if (window.confirm('Are you sure you want to sync vendors/salespeople?')) {
            this.setState({
                isSyncingVendors: true,
                statusMessage: undefined,
            });

            let response = await apifetch(
                "settings/sync/vendorsandsalespeople",
                {
                    method: "POST",
                },
                true
            );

            if (response.ok) {
                let response = await apifetch("settings", undefined, true);
                if (response.ok) {
                    let data = await response.json();

                    this.state.data.vendorSyncLogs = data.vendorSyncLogs;
                    this.setState({
                        isSyncingVendors: false,
                        data: this.state.data,
                        statusMessage: { type: "success", message: "Vendors/salespeople synced successfully." },
                    });
                } else {
                    const errorText = await extractErrorMessage(response);
                    this.setState({
                        isSyncingVendors: false,
                        statusMessage: { type: "error", message: errorText },
                    });
                }
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isSyncingVendors: false,
                    statusMessage: { type: "error", message: errorText },
                });
            }
        }
    }

    private async syncJobs() {
        if (window.confirm('Are you sure you want to sync jobs?')) {
            this.setState({
                isSyncingJobs: true,
                statusMessage: undefined,
            });

            let response = await apifetch(
                "settings/sync/jobs",
                {
                    method: "POST",
                },
                true
            );

            if (response.ok) {
                let response = await apifetch("settings", undefined, true);
                if (response.ok) {
                    let data = await response.json();

                    this.state.data.jobSyncLogs = data.jobSyncLogs;
                    this.setState({
                        isSyncingJobs: false,
                        data: this.state.data,
                        statusMessage: { type: "success", message: "Projects synced successfully." },
                    });
                } else {
                    const errorText = await extractErrorMessage(response);
                    this.setState({
                        isSyncingJobs: false,
                        statusMessage: { type: "error", message: errorText },
                    });
                }
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isSyncingJobs: false,
                    statusMessage: { type: "error", message: errorText },
                });
            }
        }
    }

    private async importTaxRates() {
        if (window.confirm('Are you sure you want to import tax rates?')) {
            this.setState({
                isImportingTaxRates: true,
                statusMessage: undefined,
            });

            let response = await apifetch(
                "settings/import/taxrates",
                {
                    method: "POST",
                },
                true
            );

            if (response.ok) {
                let response = await apifetch("settings", undefined, true);
                if (response.ok) {
                    this.setState({
                        isImportingTaxRates: false,
                        statusMessage: { type: "success", message: "Tax rates imported successfully." },
                    });
                } else {
                    const errorText = await extractErrorMessage(response);
                    this.setState({
                        isImportingTaxRates: false,
                        statusMessage: { type: "error", message: errorText },
                    });
                }
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isImportingTaxRates: false,
                    statusMessage: { type: "error", message: errorText },
                });
            }
        }
    }

    private async importData() {
        if (window.confirm('Are you sure you want to import data?')) {
            this.setState({
                isImportingData: true,
                statusMessage: undefined,
            });

            let response = await apifetch(
                "settings/import/data",
                {
                    method: "POST",
                },
                true
            );

            if (response.ok) {
                let response = await apifetch("settings", undefined, true);
                if (response.ok) {
                    this.setState({
                        isImportingData: false,
                        statusMessage: { type: "success", message: "Data imported successfully." },
                    });
                } else {
                    const errorText = await extractErrorMessage(response);
                    this.setState({
                        isImportingData: false,
                        statusMessage: { type: "error", message: errorText },
                    });
                }
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isImportingData: false,
                    statusMessage: { type: "error", message: errorText },
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/settings/index.tsx